import { createRouter, createWebHistory, type RouteLocationGeneric } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const routes = [
  { path: '/login', component: () => import('@/views/login.vue') },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '仪表盘' } },
      { path: 'tenants', component: () => import('@/views/tenants/index.vue'), meta: { title: '入驻企业管理' } },
      { path: 'contacts', component: () => import('@/views/contacts/index.vue'), meta: { title: '联系人管理' } },
      { path: 'customers', component: () => import('@/views/customers/index.vue'), meta: { title: '客户档案' } },
      { path: 'business-ledger', component: () => import('@/views/business-ledger/index.vue'), meta: { title: '商务台账' } },
      { path: 'business-case', component: () => import('@/views/business-case/index.vue'), meta: { title: '商务台账', hidden: true } },  // V1.7: 只在商务台账按钮调用，不渲染菜单;0923 改 '商务工作区'→'商务台账' 与列表一致
      { path: 'business-case/:caseId', component: () => import('@/views/business-case/index.vue'), meta: { title: '商务台账', hidden: true } },
      { path: 'hire-statement', redirect: '/voyage', meta: { title: '航次工作台' } },
      { path: 'voyage-estimate', component: () => import('@/views/voyage-estimate/index.vue'), meta: { title: '航次估算' } },
      { path: 'voyage-estimate/compare', component: () => import('@/views/voyage-estimate/compare.vue'), meta: { title: '方案对比' } },
      { path: 'voyage-workspace/:voyageId', component: () => import('@/features/voyage-handover/VoyageHandoverLive.vue'), meta: { title: '航次工作空间' } },
      { path: 'voyage-handover-live/:voyageId', redirect: (to: RouteLocationGeneric) => ({ path: `/voyage-workspace/${encodeURIComponent(String(to.params.voyageId))}`, query: { ...to.query, review: '1' } }), meta: { title: '航次工作空间', hidden: true } },
      { path: 'laytime', redirect: '/voyage', meta: { title: '航次工作台' } },
      { path: 'departments', component: () => import('@/views/departments/index.vue'), meta: { title: '部门管理' } },
      { path: 'users', component: () => import('@/views/users/index.vue'), meta: { title: '用户管理' } },
      { path: 'roles', component: () => import('@/views/roles/index.vue'), meta: { title: '角色管理' } },
      { path: 'audit', component: () => import('@/views/audit/index.vue'), meta: { title: '审计日志' } },
      { path: 'inquiry', component: () => import('@/views/inquiry/index.vue'), meta: { title: '询船管理', hidden: true } },  // V1.7: 商务台账按钮调用
      { path: 'ports', component: () => import('@/views/ports/index.vue'), meta: { title: '港口库' } },
      { path: 'fee', component: () => import('@/views/fee/index.vue'), meta: { title: '费用分类' } },
      { path: 'vessels', component: () => import('@/views/vessels/index.vue'), meta: { title: '船舶档案' } },
      // M7 备用直跳路由 — 主入口在 vessels/index.vue 行内「股东管理」按钮（dialog 触发）；
      // 此路由仅用于 owner 直接访问 /vessel-shareholder 的极少数场景
      { path: 'vessel-shareholder', component: () => import('@/views/vessels/index.vue'), meta: { title: '船舶股东', hidden: true } },
      { path: 'psc/:vesselId', component: () => import('@/views/psc/index.vue'), meta: { title: 'PSC记录' } },
      { path: 'crew/:vesselId', component: () => import('@/views/crew/index.vue'), meta: { title: '船员管理' } },
      { path: 'brokerage', component: () => import('@/views/brokerage/index.vue'), meta: { title: '委托管理', hidden: true } },  // V1.7: 商务台账按钮调用
      { path: 'broker-deals', component: () => import('@/views/broker-deals/index.vue'), meta: { title: '经纪与委托统一入口', hidden: true } },  // V1.7: 商务台账按钮调用
      { path: 'shareholder-dashboard', component: () => import('@/views/shareholder-dashboard/index.vue'), meta: { title: '股东驾驶舱' } },
      { path: 'invoice', component: () => import('@/views/invoice/index.vue'), meta: { title: '发票管理' } },
      { path: 'payable', component: () => import('@/views/payable/index.vue'), meta: { title: '应付款管理' } },
      { path: 'receivable', component: () => import('@/views/receivable/index.vue'), meta: { title: '应收款管理' } },
      { path: 'kanban', component: () => import('@/views/kanban/index.vue'), meta: { title: '工作看板' } },
      { path: 'sea-routes', component: () => import('@/views/sea-routes/index.vue'), meta: { title: '航线管理' } },
      { path: 'voyage', component: () => import('@/features/voyage-handover/VoyageList.vue'), meta: { title: '航次管理' } },
      { path: 'voyage-events', component: () => import('@/views/voyage-events/index.vue'), meta: { title: '航次事件' } },
      { path: 'cargo-movement', component: () => import('@/views/cargo-movement/index.vue'), meta: { title: '货物流转' } },
      { path: 'document-engine', component: () => import('@/views/document-engine/index.vue'), meta: { title: '文档引擎' } },
      { path: 'daily-report', component: () => import('@/views/daily-report/index.vue'), meta: { title: '日报' } },
      { path: 'payment-gate', component: () => import('@/views/payment-gate/index.vue'), meta: { title: '付款门禁' } },
      { path: 'voyage-settlement', redirect: '/voyage', meta: { title: '航次工作台' } },
      { path: 'voyage-handover', redirect: '/voyage', meta: { title: '航次工作台' } },
      { path: 'contracts', component: () => import('@/views/contracts/index.vue'), meta: { title: '合同管理', hidden: true } },  // V1.7: 商务台账按钮调用
      { path: 'subjects', component: () => import('@/views/subjects/index.vue'), meta: { title: '船况声明', hidden: true } },  // V1.7: 商务台账按钮调用
      // V1.7: 审批人员配置（仅管理员可见 — 后端路由做了 is_active 控制，前端通过 isAdmin 判定隐藏入口）
      {
        path: 'settings/approval-assignees',
        component: () => import('@/views/settings/ApprovalAssignees.vue'),
        meta: { title: '审批人员配置', requiresAdmin: true },
      },
      // 1021 银行账户门禁整改 D-2：我方公司档案 + 我方收款账户（获批后才可进发票快照）
      //   菜单条目由后端 permission_tree 的 menu:settings 节点下发，前端只注册路由（只增不改）
      {
        path: 'settings/company-profile',
        component: () => import('@/views/company-profile/index.vue'),
        meta: { title: '我方公司档案' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫 — 需要认证的路由
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()
  
  // 不需要认证直接放行
  if (!to.meta.requiresAuth) {
    next()
    return
  }
  
  const token = localStorage.getItem('access_token')
  if (!token) {
    next('/login')
    return
  }
  
  // 等待 auth store 初始化完成
  if (authStore.isInitializing) {
    await authStore.initPromise
  }
  
  // 初始化完成后检查用户状态
  if (!authStore.user || typeof authStore.user !== 'object') {
    next('/login')
    return
  }

  // V1.7: requiresAdmin 路由校验（非管理员跳回 dashboard）
  if (to.meta.requiresAdmin) {
    const u: any = authStore.user
    const isAdmin = u?.is_superuser || u?.role === 'super_admin' || u?.role === 'tenant_admin'
    if (!isAdmin) {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
